import { render, staticRenderFns } from "./teamDelete.vue?vue&type=template&id=535092bf"
import script from "./teamDelete.vue?vue&type=script&lang=js"
export * from "./teamDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports